import { AuditEntity } from "@app/common";
import { Cost } from "@app/core";
import { CustomerType } from "@app/customers-base";
import { Column, Display, prop, propArray, required, Table } from "@messaia/cdk";
import { BillSource } from "../enums/bill-source";
import { TariffSection } from "../enums/tariff-section";
import { Bundle } from "./bundle";
import { TariffFootnote } from "./tariff-footnote";

@Table({
	endpoint: 'tariff',
	duplicable: true,
	includes: ['Client']
})
export class Tariff extends AuditEntity {
	@Column()
	@Display($localize`:@@name:Name`)
	@required()
	name: string;

	@Column({ showGtLg: true })
	@Display($localize`:@@nameIntern:Name intern`)
	@required()
	nameIntern: string;

	@Column({ enumType: CustomerType, showGtMd: true })
	@Display($localize`:@@customerType:Customer type`)
	@required()
	customerType: CustomerType;

	@Column({ name: 'client.displayName', endpoint: 'client?enabled=true&projection=id,name', maxWidth: 250, showGtXl: true })
	@Display($localize`:@@client:Client`)
	@required()
	clientId: number;

	@Column({ event: 'toggle' })
	@Display($localize`:@@enabled:Enabled`)
	@prop()
	enabled: boolean;

	@required()
	section: TariffSection;

	@prop()
	description: string;

	@prop()
	providerId: number;

	@required()
	billSource: BillSource;

	@prop()
	imagePath: string;

	@prop()
	image: string;

	@prop()
	imageFootnote: string;

	thumnb: string;

	@prop()
	startDate: Date;

	@prop()
	endDate: Date;

	@prop()
	hasAvailabilityCheck: boolean = true;

	@prop()
	hasTAELocation: boolean;

	@prop()
	hasItemizedBillType: boolean = true;

	@prop()
	hasPhoneNumberBlocks: boolean = false;

	@prop()
	default: boolean = true;

	@propArray(Bundle)
	bundles: Bundle[] = [];

	@propArray(TariffFootnote)
	footnotes: TariffFootnote[] = [];

	@prop()
	voIP: boolean;

	@required({ conditionalExpression: (x: Tariff) => x.voIP })
	maxVoipNumbers: number;

	@required({ conditionalExpression: (x: Tariff) => x.voIP })
	freePhoneNumberCount: number;

	@required({ conditionalExpression: (x: Tariff) => x.voIP })
	maxImportableNumbers: number;

	costs: Cost[];

	@required()
	ordering: number = 0;
}